// extracted by mini-css-extract-plugin
module.exports = {"root":"gallery_root__KhTPP","title":"gallery_title__Q_ur1","subtitle":"gallery_subtitle__UIicj","text":"gallery_text__PPCet","btn":"gallery_btn__kT_3e"};